import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import logoFooter from "../Assets/logo_footer.png";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <div className="footer-content-wrapper">
        <div className="footer-logo-background">
          <img
            src={logoFooter}
            alt="동진에어텍 로고"
            className="footer-logo-bg"
          />
        </div>
        <Row className="footer-content">
          <Col className="footer-text-section">
            <div className="footer-company-info">
              <h3 className="footer-company-name">
                동진에어텍(주) DONGIN AIRTEC Co. Ltd
              </h3>
              <p>
                사업자번호 :
                109-86-10094&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;대표
                : 신동찬
              </p>
              <p>대표 전화 : 031-790-1900 / 031-790-1901</p>
              {/* <p>핸드폰번호: 010-3038-9709</p> */}
              <p>Email : dongjinat@nate.com</p>
              <p>FAX : 031-790-1902</p>
              <p>본사: 경기도 하남시 미사강변중앙로 7번안길, B동 2층 201호 (풍산동, u-테크벨리) </p>
              <p>영업본부: 경기도 하남시 조정대로 150 아이테코 731호</p>
              <p>All rights reserved {year}</p>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Footer;
